<template>
  <div class="container"> 
    <div class="row">
        <div class="col-4 mt-3">
           <!-- Button trigger modal -->
<button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6" type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
 პროგრამის რეგისტრაცია
</button>
 
<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
      
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
 <form>
        <div class="mb-3">
 
  <input type="text" class="form-control" placeholder="პროგრამის დასახელება" v-model="programname">
</div>
        <select class="form-select" v-model="program_typeID">
  <option selected value="0">პროგრამის ტიპი</option>
  <option :value="program_type.program_typeID" v-for="program_type in program_types"
   :key="program_type.program_typeID">{{program_type.program_type}}</option>
  
</select>

<div class="mt-2">
 
 <input type="number" class="form-control" placeholder="პროგრამის საფასური" v-model="Programfee">
</div>

</form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="saveprogram()">შენახვა</button>
      </div>
    </div>
  </div>
</div>



<!-- modules -->


<div class="modal fade" id="exampleModalModules" tabindex="-1" aria-labelledby="exampleModalModulesLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
      
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

          <input type="text" v-model="searchModule" class="form-control" placeholder="ძებნა"/>

          <div class="mt-3">
            <ul>
              <li  v-for="module in filteredModules" :key="module.moduleID" style="cursor: pointer;" @click="chooseModule(module)">{{ module.module_name }}</li>
            </ul>
          </div>
            <hr>
            <div class="mt-3" v-if="moduleIDs.length>0">
              <h4 class="text-center">არჩეული მოდულები</h4>
            <ul>
              <li  v-for="module in moduleIDs" :key="module.moduleID" style="cursor: pointer;">{{ module.module_name }} <span style="color: red; font-size: 20px;" @click="removeFromArrayModule(module.moduleID)">X</span></li>
            </ul>
          </div>

           
        
 
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="saveprogrammodule(theChosenProgramID)">შენახვა</button>
      </div>
    </div>
  </div>
</div>






        </div>
    </div>
              <div class="row ">
                <div class="col-12 col-md-6 col-lg-3 mt-3" v-for="program in programs" :key="program.programID">
                        <div class="card  card-color-border">
                  <div class="card-body ">
                      <h5 class="card-title text-center text-color">{{ program.program_name }} - {{ program.fee }} ლარი</h5>
                      <p class="text-center text-color">{{ program.program_types.program_type }}</p>
                      <div class="d-flex justify-content-end">
                              <div class="col-2 text-color fs-5">
                        <span v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6" @click="chosenProgram(program.programID)" data-bs-toggle="modal" data-bs-target="#exampleModalModules" style="cursor:pointer">  <i class='bx bx-plus'></i> </span>
                                    </div>
                              </div>
                              
                      <ol start="1" class="text-color">
                              <li v-for="program_module in program.program_modules" :key="program_module.program_modulesID"> {{ program_module.modules.module_name }} <span v-if="this.$store.state.user.positionID==1" @click="removeModule(program_module.program_modulesID)" style="cursor:pointer"><i class='bx bx-x'></i> </span></li>
 
                      </ol>
                        
                  </div>

                  </div>
              </div> 
         
</div>
     </div> 
</template>

<script>

import HttpRequests from '../httpRequests/httpRequests';
    const httpRequests=new HttpRequests()
    
export default{

  data(){
    return{
      program_types:[],
      programname:null,
      Programfee:0,
      program_typeID:0,
      programs:[],
      moduleIDs:[],
      modules:[],
      theChosenProgramID:0,
      searchModule:'',
      filteredModules:[]

    }

  },
   
  watch:{
    searchModule(val){

      if(val!=''){
  
       this.filteredModules=this.modules.filter(o=>o.module_name.includes(val))

      }else {

        this.filteredModules=[]

      }

    }

  },

  mounted(){

    httpRequests.programtype().then(response=>{
      this.program_types=response.data
       })

       httpRequests.getPrograms().then(response=>{
        this.programs=response.data
       })

       httpRequests.getModule().then(response=>{
        this.modules=response.data
       
    })
    },
    methods:{

      chooseModule(module){

        if(!this.moduleIDs.find(o=>o.moduleID==module.moduleID)){

        this.moduleIDs.push({
          moduleID:module.moduleID,
          module_name:module.module_name

        })
      }
 
      },

      removeFromArrayModule(moduleID){

        if(confirm("ნამდვილად გსურთ ამოშლა?")){
        this.moduleIDs.splice(this.moduleIDs.findIndex(o=>o.moduleID==moduleID),1)
        }

      },

      saveprogram(){

        httpRequests.saveprogram(this.programname,this.program_typeID,this.Programfee).then(()=>{
          location.reload()
        })
      },
      chosenProgram(programID){
          this.theChosenProgramID=programID

      },
      saveprogrammodule(programID){

        httpRequests.saveprogrammodule(this.moduleIDs,programID).then(()=>{
          location.reload()
        })
 

      },
      removeModule(program_moduleID){

        if(confirm("ნამდვილად გსურთ პროგრამიდან ამოშლა?")){

        httpRequests.removeModule(program_moduleID).then(()=>{
          location.reload()
        })
      }
      }

    }
 }



</script>